import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';
import { BlueLink } from 'components/common/link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  line-height: 3.5rem;
  @media (max-width: 999px) {
    padding: 0;
  }
`;
const FirstText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 30px;
  text-align: center;
  margin: 36px;
  @media (max-width: 999px) {
    font-size: 25px;
    margin: 16px;
  }
`;
const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 16px;
  text-align: center;
  white-space: break-spaces;
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratLight};
  font-size: 17px;
`;

export const SubscriptionAssociatedModal = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  return (
    <Container>
      <FirstText>{TRANSLATION_TEXT.great_news}</FirstText>
      <SecondText>{TRANSLATION_TEXT.you_already_have_an_active_subscription}</SecondText>
      <SecondText>
        {`${TRANSLATION_TEXT.to_access_all_members_features_and_content} `}
        <StyledLink to={'https://rapaport.com/authorization/'} external newTab>
          {TRANSLATION_TEXT.click_here_to_login}
        </StyledLink>
      </SecondText>
      <SecondText>{TRANSLATION_TEXT.your_username_is_your_email_address}</SecondText>
      <SecondText>{TRANSLATION_TEXT.we_looking_forward_to_serving_you}</SecondText>
    </Container>
  );
};
export default SubscriptionAssociatedModal;
